// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center {
  width: 25%;
  margin: 10px auto;
}

.main-div {
  height: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

button {
  margin-right: 10px;
}

/*.mat-icon {
  horizontal-align: right;

}*/
th {
  font-weight: bold;
  background-color: #E6E8EB;
}

table {
  width: 100%;
}

table thead th {
  color: white;
  font-size: 10pt;
  background-color: #3b5998;
}

.make-gold {
  background-color: #FAF6E2;
}

.make-red {
  background-color: #F0DDDD;
}

.make-green {
  background-color: #DEEED7;
}

li {
  margin-top: 5px;
  margin-left: 10px;
  padding: 2px;
}

.mat-fab {
  min-width: 100px;
  min-height: 75px;
}

.badge {
  float: right;
}

.content {
  padding: 5px;
}

.content > mat-card {
  width: 100px;
}

.nolist {
  list-style: none;
}

.example-margin {
  float: right;
  margin: 5px;
}

.example-headers-align {
  display: block;
  margin-top: 20px;
}

.badge {
  margin-left: auto;
}

.mat-expansion-panel {
  margin-bottom: 10px;
}

.mat-expansion-panel-header {
  margin-top: 10px;
}

.error-box {
  border-style: solid;
  border-color: rgb(224, 52, 52);
  color: #0a0a0a;
}

.table-container {
  overflow-x: auto;
  max-width: 100%;
  margin-bottom: 10px;
}

.custom-table {
  width: 100%;
}

.heading {
  margin: auto;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  white-space: nowrap; /* Prevent text wrapping */
  overflow: hidden; /* Hide overflowing content */
  text-overflow: ellipsis; /* Show ellipsis for truncated text */
}

.edit-button {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/small-molecule/small-molecule.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,iBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AACA;EACE,kBAAA;AAEF;;AACA;;;EAAA;AAIA;EACE,iBAAA;EACA,yBAAA;AAEF;;AAAA;EACE,WAAA;AAGF;;AADA;EAAiB,YAAA;EAAc,eAAA;EAAgB,yBAAA;AAO/C;;AANA;EACE,yBAAA;AASF;;AAPA;EACE,yBAAA;AAUF;;AARA;EACE,yBAAA;AAWF;;AARA;EACE,eAAA;EACA,iBAAA;EACA,YAAA;AAWF;;AARA;EACE,gBAAA;EACA,gBAAA;AAWF;;AARA;EACE,YAAA;AAWF;;AAPA;EACE,YAAA;AAUF;;AAPA;EACE,YAAA;AAUF;;AAPA;EACE,gBAAA;AAUF;;AAPA;EACE,YAAA;EACA,WAAA;AAUF;;AANA;EACE,cAAA;EACA,gBAAA;AASF;;AANA;EACE,iBAAA;AASF;;AANA;EACE,mBAAA;AASF;;AANA;EACE,gBAAA;AASF;;AANA;EACE,mBAAA;EACA,8BAAA;EACA,cAAA;AASF;;AANA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;AASF;;AALA;EACE,WAAA;AAQF;;AALA;EACE,YAAA;AAQF;;AAJA;EACE,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA,EAAA,0BAAA;EACA,gBAAA,EAAA,6BAAA;EACA,uBAAA,EAAA,qCAAA;AAOF;;AAJA;EACE,eAAA;AAOF","sourcesContent":[".center{\r\n  width: 25%;\r\n  margin: 10px auto;\r\n}\r\n\r\n.main-div{\r\n  height: 30vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\nbutton {\r\n  margin-right: 10px;\r\n}\r\n\r\n/*.mat-icon {\r\n  horizontal-align: right;\r\n\r\n}*/\r\nth {\r\n  font-weight: bold;\r\n  background-color: #E6E8EB;\r\n}\r\ntable {\r\n  width: 100%;\r\n}\r\ntable thead th { color: white; font-size:10pt; background-color: #3b5998}\r\n.make-gold {\r\n  background-color: #FAF6E2;\r\n}\r\n.make-red {\r\n  background-color: #F0DDDD;\r\n}\r\n.make-green {\r\n  background-color: #DEEED7;\r\n}\r\n\r\nli{\r\n  margin-top: 5px;\r\n  margin-left: 10px;\r\n  padding: 2px;\r\n}\r\n\r\n.mat-fab {\r\n  min-width: 100px;\r\n  min-height: 75px;\r\n}\r\n\r\n.badge {\r\n  float: right;\r\n}\r\n\r\n\r\n.content {\r\n  padding: 5px;\r\n}\r\n\r\n.content > mat-card {\r\n  width: 100px;\r\n}\r\n\r\n.nolist {\r\n  list-style: none;\r\n}\r\n\r\n.example-margin {\r\n  float: right;\r\n  margin: 5px;\r\n}\r\n\r\n\r\n.example-headers-align{\r\n  display: block;\r\n  margin-top: 20px;\r\n}\r\n\r\n.badge{\r\n  margin-left: auto;\r\n}\r\n\r\n.mat-expansion-panel{\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.mat-expansion-panel-header{\r\n  margin-top: 10px;\r\n}\r\n\r\n.error-box{\r\n  border-style: solid;\r\n  border-color:rgb(224, 52, 52);\r\n  color: #0a0a0a;\r\n}\r\n\r\n.table-container {\r\n  overflow-x: auto;\r\n  max-width: 100%; \r\n  margin-bottom: 10px;\r\n \r\n}\r\n\r\n.custom-table {\r\n  width: 100%;\r\n}\r\n\r\n.heading{\r\n  margin: auto;\r\n \r\n}\r\n\r\nth, td {\r\n  border: 1px solid #ddd;\r\n  padding: 8px;\r\n  text-align: left;\r\n  white-space: nowrap; /* Prevent text wrapping */\r\n  overflow:hidden; /* Hide overflowing content */\r\n  text-overflow: ellipsis; /* Show ellipsis for truncated text */\r\n}\r\n\r\n.edit-button{\r\n  cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
